import Request from "./requests";
import {handlePublicConfigAction, setPublicConfigAction} from "../redux/actions/getPublicConfigAction";

export function getPublicConfig(params) {
    let r = new Request();
    return r.get('sys/public-config', params, setPublicConfigAction, handlePublicConfigAction)
}
